import styles from './ReviewSection.module.scss';
import ReviewCarousel from '../ReviewCarousel';

function ReviewSection() {
  return (
    <div className={styles.container}>
      <ReviewCarousel />
    </div>
  );
}

export default ReviewSection;
